<template>
	<div class="other_page_r">
		<el-card class="card_box">
			<div slot="header" class="card_title">
				<span>预测市场/市场列表</span>
			</div>
			<div>
				<el-form :inline="true" :model="searchInfo" class="demo-form-inline">
					<el-form-item label="市场ID">
						<el-input
							class="custom_input_60"
							v-model="searchInfo.id"
							placeholder=""
						>
						</el-input>
					</el-form-item>

					<el-form-item label="市场标题">
						<el-input
							class="custom_input_100"
							v-model="searchInfo.title"
							placeholder=""
						>
						</el-input>
					</el-form-item>

					<el-form-item label="状态">
						<el-select
							class="custom_input_80"
							v-model="searchInfo.status"
							placeholder=""
						>
							<el-option label="活跃" value="active"></el-option>
							<el-option label="关闭" value="closed"></el-option>
							<el-option label="结束" value="ended"></el-option>
						</el-select>
					</el-form-item>

					<el-form-item label="时间段">
						<el-date-picker
							v-model="searchInfo.dataRanger"
							type="daterange"
							size="large"
							range-separator="至"
							start-placeholder="开始日期"
							end-placeholder="结束日期"
							value-format="yyyy-MM-dd"
						>
						</el-date-picker>
					</el-form-item>

					<el-form-item>
						<el-button class="search-btn" type="primary" @click="searchBtn"
							>查询</el-button
						>
						<el-button class="search-btn" type="primary" @click="reset"
							>重置</el-button
						>
						<el-button
							class="search-btn"
							type="primary"
							@click="exportExcel"
							:loading="downloadLoading"
							>导出</el-button
						>
					</el-form-item>
				</el-form>
			</div>
			<div class="table_box">
				<tablec :tableData="tableData" :from="from"></tablec>
			</div>
			<div
				class="flex justify_content_end aligin_items_c table_footer custom_btn"
			>
				<div>
					<pagination
						v-show="total > 0"
						:total="total"
						:page.sync="searchInfo.page"
						:limit.sync="searchInfo.size"
						@pagination="getDataList"
					/>
				</div>
			</div>
		</el-card>
	</div>
</template>

<script>
import FileSaver from "file-saver";
import * as XLSX from "xlsx";
import tablec from "./tablec.vue";
import {
	getMarketList,
} from "@/api/prediction";
import { searchMixin } from "@/utils/searchMixin.js";

export default {
	mixins: [searchMixin],
	components: { tablec },
	name: "",
	data() {
		return {
			tableData: [],
			total: 0,
			downloadLoading: false,
			searchInfo: {
				title: "",
				status: "",
				page: 1,
				size: 10,
				id: "",
				dataRanger: "",
				event_id: this.$route.query.event_id || "",
			},
			from: 0,
		};
	},
	created() {
		let _obj = JSON.parse(sessionStorage.getItem("marketListKey"));
		if (_obj) {
			Object.keys(this.searchInfo).forEach((key) => {
				this.searchInfo[key] = _obj[key] || this.searchInfo[key];
			});
		}
		this.getDataList();
	},
	methods: {
		exportExcel() {
			this.downloadLoading = true;
			const headers = [
				"市场ID",
				"市场标题",
				"交易量",
				"流动性",
				"当前价格",
				"状态",
				"创建时间",
			];
			const fields = [
				"id",
				"title",
				"volume",
				"liquidity",
				"current_price",
				"status",
				"create_time",
			];

			const formatDataForExcel = (data) => {
				const rows = data.map((item) =>
					fields.map((field) => {
						if (field === "status") {
							return item[field] === "active"
								? "活跃"
								: item[field] === "closed"
								? "关闭"
								: item[field] === "ended"
								? "结束"
								: "";
						}
						return item[field];
					})
				);
				return [headers, ...rows];
			};

			const par = this.searchInfo;
			par["size"] = 10000;
			getMarketList(par)
				.then((res) => {
					console.log(res);
					this.loading = false;
					var data = res.data.data;
					const ws = XLSX.utils.aoa_to_sheet(formatDataForExcel(data));
					const wb = XLSX.utils.book_new();
					XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

					const wbout = XLSX.write(wb, {
						bookType: "xlsx",
						bookSST: true,
						type: "array",
					});

					try {
						FileSaver.saveAs(
							new Blob([wbout], {
								type: "application/octet-stream",
							}),
							"市场列表" + ".xlsx"
						);
					} catch (e) {
						if (typeof console !== "undefined") console.log(e, wbout);
					}

					this.downloadLoading = false;
				})
				.catch((error) => {
					console.error("导出失败:", error);
					this.downloadLoading = false;
				});
		},
		searchBtn() {
			this.searchInfo.page = 1;
			this.getDataList();
		},
		getDataList() {
			let _data = Object.assign(this.searchInfo, {});
			sessionStorage.setItem("marketListKey", JSON.stringify(_data));
			const that = this;
			getMarketList(this.searchInfo)
				.then((res) => {
					console.log(res);
					if (res.code == 200) {
						that.tableData = res.data.data;
						that.total = res.data.total;
						this.from = 0;
					} else {
						that.tableData = [];
						that.total = 0;
					}
					this.loading = false;
				})
				.catch((error) => {
					this.$message.error(error.message);
				});
		},
		reset() {
			this.searchInfo = {
				title: "",
				status: "",
				page: 1,
				size: 10,
				id: "",
				dataRanger: "",
				event_id: this.$route.query.event_id || "",
			};
			this.getDataList();
		},
	},
};
</script>

<style scoped></style>